import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../redux/reducers/info";
import logoImg from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-04.png"
import RoleAccess from '../RoleAccess'
import useUserRole from '../../hooks/useUserRole'

// Sidebar Images
import dashboardLight from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-21.png";
import dashboardDark from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-38.png";
import vendorLight from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-22.png";
import vendorDark from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-37.png";
import customerLight from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-26.png";
import customerDark from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-33.png";
import reports from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-23.png";
import reportsDark from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-35.png";
import observant from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-29.png";
import observantDark from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-30.png";
import logs from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-34.png";
import logsDark from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-25.png";
// import points from "../../assets/images/Category Icon-01.png";
// import pointsDark from "../../assets/images/Category Icon-02.png";
import logout from "../../assets/images/Admin-Affiliate-Seller Center-Portal-Assets-31.png";
import { useUser } from "../../context/userContext";


const Sidebar = ({ index }) => {
    const [open, setOpen] = useState(true);
    const [showSidebar, setShowSidebar] = useState(false);
    const roles = useUserRole()
    const [list] = useState([
        {
            name: "Dashboard",
            light: dashboardLight,
            dark: dashboardDark,
            url: "/dashboard",
            index: "1",
            id: "dashboard"
        },
        // {
        //     name: "Approval Request",
        //     light: customerLight,
        //     dark: customerDark,
        //     url: "/approvalRequest",
        //     index: "7",
        //     id: "approvalRequest"
        // },
        {
            name: "Services",
            light: vendorLight,
            dark: vendorDark,
            url: "/services",
            index: "4",
            id: "services"
        },
        {
            name: "Sales Representative",
            light: customerLight,
            dark: customerDark,
            url: "/",
            index: "3",
            id: "salesRepresentative",
            subMenu: [
                {
                    name: "All Sales Representative",
                    url: "/saleRepresentative",
                    index: "3a",
                    id: "saleRepresentative",
                },
                {
                    name: "Create Sales Representative",
                    url: "/createSale",
                    index: "3b",
                    id: "createSale",
                },
            ]
        },
        {
            name: "Sales Report",
            light: reports,
            dark: reportsDark,
            url: "/sales",
            index: "9",
            id: "sales"
        },
        {
            name: "Observant Users",
            light: observant,
            dark: observantDark,
            url: "/",
            index: "5",
            id: "observantUsers",
            subMenu: [
                {
                    name: "All Observants users",
                    url: "/allObservantsUsers",
                    index: "5a",
                    id: "allObservantsUsers",
                },
                {
                    name: "Create observant user",
                    url: "/createObservantUser",
                    index: "5b",
                    id: "createObservantUser",
                },
            ]
        },
        {
            name: "Regional Managers",
            light: customerLight,
            dark: customerDark,
            url: "/",
            index: "8",
            id: "regionalManagers",
            subMenu: [
                {
                    name: "Regional Managers",
                    url: "/allRegionalManagers",
                    index: "8a",
                    id: "allRegionalManagers",
                },
                {
                    name: "Create Regional Managers",
                    url: "/createManager",
                    index: "8b",
                    id: "createManager",
                },
            ]
        },
        // {
        //     name: "Points",
        //     light: pointsDark,
        //     dark: points,
        //     url: "/points",
        //     index: "2",
        //     id: "points"
        // },
        {
            name: "Logs",
            light: logsDark,
            dark: logs,
            url: "/logs",
            index: "6",
            id: "logs"
        },

    ])
    const disptach = useDispatch()
    const { sidebarState } = useSelector((state) => state.tooltipInfo);
    const [event, setEvent] = useState(sidebarState)
    const navigate = useNavigate();
    const componentRef = useRef();
    const componentRef2 = useRef();
    const { userType } = useUser();

    // getting name to show
    const gettingName = () => {
        if (userType === 'admin') return "Admin";
        if (userType === 'salesAgent') return "Sales Representative";
        if (userType === 'regionalManager') return "Regional Manager";
        if (userType === 'user') return "Observant User";
    }

    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
        // eslint-disable-next-line
    }, []);

    function handleClick(e) {
        if (window.innerWidth <= 700) {
            const toggleRef = componentRef.current;
            const outsideRef = componentRef2.current;
            if (!outsideRef?.contains(e.target) && !toggleRef?.contains(e.target)) {
                setOpen(false);
            }
        }
    }

    const handleRoute = (route) => {
        if (route === "logout") {
            window.localStorage.clear();
            window.location.reload();
        } else {
            navigate(`/${route}`);
        }
    };

    const handleSubMenu = (item) => {
        if (item?.url === '/createObservantUser' || item?.url === '/createSale' || item?.url === '/createManager') {
            return navigate(item?.url, { state: { createSuccess: true } })
        }
        navigate(item?.url)
    }

    const handleLogout = () => {
        localStorage.clear();
        window.location.reload();
    };

    const handleRouteClick = (item) => {
        console.log("item", item)
        if (item.subMenu) {
            setEvent(item.index !== event ? item.index : null);
            disptach(toggleSidebar({ event: item.index !== event ? item.index : null }));
        }
        else {
            navigate(item?.url);
        }
    };
    console.log("event", event)

    useEffect(() => {
        const handleResize = () => {
            setOpen(window.innerWidth >= 700);
        };

        const resizeTimeout = setTimeout(() => {
            handleResize();
            setShowSidebar(true);
        }, 100);

        window.addEventListener('resize', handleResize);

        return () => {
            clearTimeout(resizeTimeout);
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-lin
    }, []);

    return (
        <>
            <div className="navBar" ref={componentRef}>
                <div className="navBar_left">
                    <i
                        className="fas fa-bars"
                        onClick={() => setOpen((prev) => !prev)}
                    ></i>
                    <img
                        className="navBar_logo"
                        src={logoImg}
                        alt="logo"
                        onClick={() => handleRoute("")}
                    />
                </div>
                <div className="navBar_right">
                    {/* <p className="navBar_name">{gettingName()}</p> */}
                </div>
            </div>
            {
                showSidebar &&
                <div className={!open ? "sideBar" : "sideBar sideBar_sidebarActive"} ref={componentRef2}>
                    <div className={open ? "sideBar_inner" : "sideBar_innersmall"}>
                        <p className="navBar_name">{gettingName()}</p>
                        <ul>
                            {list?.map(item => {
                                return (
                                    <>
                                        <RoleAccess role={!roles?.hide?.includes(item?.id)}>

                                            <li onClick={() => handleRouteClick(item)} className={index === item?.index ? "sideBar_title sideBar_active" : "sideBar_title"}>
                                                <img alt="logo" src={index === item?.index ? item?.light : item?.dark} />
                                                {item?.name}
                                                {item?.subMenu && (
                                                    <i className={event === item?.index ? "fas fa-chevron-down" : "fas fa-chevron-right"}></i>
                                                )}
                                            </li>
                                        </RoleAccess>
                                        {event === item?.index && (
                                            <div className="sideBar_list sideBar_active">
                                                <ul>
                                                    {item?.subMenu?.map((res) => (
                                                        <RoleAccess role={!roles?.hide?.includes(res?.id)}>
                                                            <li
                                                                key={res.index}
                                                                className={index === res.index ? "sideBar_subMenu sideBar_active" : "sideBar_subMenu"}
                                                                onClick={() => handleSubMenu(res)}>
                                                                {res.name}
                                                            </li>
                                                        </RoleAccess>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </>
                                )
                            })}


                            <li className="sideBar_title" onClick={() => handleLogout("")} >
                                <img src={logout} alt="logo" />
                                Logout
                            </li>
                        </ul>

                    </div>
                </div>
            }
        </>

    );
};

export default Sidebar;
